<template>
  <div class="uk-container">
    <div class="uk-flex-center" uk-grid>
      <div class="uk-width-auto">
        <div class="uk-card uk-card-default card-availability">
          <div class="uk-card-header uk-text-center">
            <h3 class="uk-card-title">Update Availability</h3>
            <p class="uk-text-meta">Update your availability. <span uk-tooltip="Availability can be changed at any time and will be updated immediately"><i class="icon gg-info" /></span></p>
          </div>
          <div class="uk-card-body uk-padding-remove">
            <timetable ref="timetable" :data="availability" type="edit" />
          </div>
          <div class="uk-card-footer uk-text-center">
            <button class="uk-button uk-button-primary" :disabled="!updatedAvailability || availability === updatedAvailability" data-cy="btn-availability-update" @click="update">Update</button>
          </div>
        </div>
      </div>
    </div>

    <div id="update-modal" uk-modal data-cy="modal-availability-success">
      <div class="uk-modal-dialog">
        <div class="uk-modal-body" data-cy="message">Availability was updated successfully!</div>
        <div class="uk-modal-footer uk-text-center">
          <div class="uk-button uk-button-primary uk-margin-right" @click="modal.hide()">Continue Updating</div>
          <div class="uk-button uk-button-primary" data-cy="btn-back" @click="back()">View Availability</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Timetable from '@/components/Timetable.vue'

export default {
  name: 'ViewDentistAvailabilityUpdate',

  components: {
    Timetable
  },

  data() {
    return {
      modal: null,
      updatedAvailability: null
    }
  },

  computed: {
    availability() {
      return this.$store.getters['dentists/availability']()
    }
  },

  mounted() {
    this.modal = this.$uikit.modal('#update-modal')
    this.$watch(() => this.$refs.timetable.formattedAvailability, (value) => { this.updatedAvailability = value })
  },

  methods: {
    async update() {
      if (this.$store.getters['account/type'] === 'dentist') {
        this.$store.dispatch('dentists/updateAvailability', this.updatedAvailability)
          .then(() => {
            this.modal.show()
          })
          .catch((error) => {
            this.$uikit.notification({ message: 'Something went wrong! Please try again later or contact administrator!', status: 'danger' })
            console.log(error)
          })
      }
    },

    back() {
      this.modal.hide()
      this.$router.push({ name: 'dentist-availability-view' })
    }
  }
}
</script>

<style lang="scss" scoped>
 .card-availability {
    width: 100%;
    max-width: 600px;
 }
</style>
